var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-left":"20px","margin-top":"20px"}},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('form-section',{attrs:{"title":_vm.steps[_vm.currentStep.index].subtitle}},[_c('el-button',{staticClass:"allow-button",on:{"click":_vm.completeStep}},[_vm._v("\n          complete step\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fa3f11c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/tests/page/StepThree.vue
// module id = null
// module chunks = 